import React from 'react'
import './Companias.css'
import Header from '../Header/Header'
import CompaniasData from '../../Components/Admin/CompaniasData/CompaniasData'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'
export default function Companias() {
    return (
        <div className='containerGrid'>
            <Header />
            <section className='containerSection'>
                <HeaderDash />
                <div className='container'>
                    <CompaniasData />
                </div>
            </section>
        </div>
    )
}

